import { makeChartComp } from '../../util/makeChartComp';
var ViolinChart = makeChartComp('Violin');
export default ViolinChart;
